import BaseApi from "@logics/api/baseApi";
import { ApiResponseDto } from "@models/client";
import { ResponseUserDetail } from "@models/data-contracts";

const authApi = new BaseApi("");

export const fetchUserProfile = () =>
  authApi.get<ApiResponseDto<ResponseUserDetail>>("/user");
